import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Header} from './header.js';
import {Footer} from './footer.js';
import './landing.css';
import * as util from './util.js';
import iconMagnifier from './resource/magnifier.png';
import iconOffer from './resource/offer.png';
import iconNews from './resource/news.png';
import iconInformativ from './resource/informativ.png';
import iconSearchSuggestion from './resource/searchSuggestion.png';

let faqLanding = [
  {
    content: "Nur einige Beispiele: <ul><li>Software-Module im Bereich Ihres KIS </li><li>Erweiterungen  Ihres Zentralsystems  mit weiteren Funktionen </li><li>Im System  vorher nicht  vorhandene  Auswertungen,  die Sie oder die für  Sie geschrieben wurden </li><li>Datenschutz-Regelungen und -Umsetzungspapiere </li><li>Vorlagen</li><li>erfolgreiche  oder erfolglose  Anträge (z.B. Großgeräte-Anträge) <Leistungsverzeichnisse</li><li>Strategiepapiere </li><li>Verträge jeglicher Art </li><li>SOPs </li><li>SLAs </li><li>Dienstanweisungen </li><li>Personalratsvorlagen</li><li>nützliche Links </li><li>sinnvolles aus Ministerien, BMG </li><li>Gesetzesvorlagen,  Verordnungen </li><li>Fragebögen </li><li>Excel-Sheets </li><li>Präsentationen und Vorträge </li><li>Outplacement-Verträge</li><li>geschickte Trennungsrechnungs-Konzepte  Skripte</li><li>Hilfen Ihrer Mannschaft  an andere, die Sie als Dienstleistung  anbieten können.</li></ul>",
    title: "Wollen Sie Vorschläge, was Sie einstellen könnten?",
    key: "0",
  },
  {
    content: "Anbieten darf jeder, der etwas anzubieten hat, solange es sein (auch geistiges) Eigentum ist: Krankenhäuser, Institutionen, Firmen und Privatpersonen.",
    title: "Wer darf anbieten?",
    key: 1,
  },
  {
    content: "Nur registrierte Mitglieder können:</br><ul><li>Preise angezeigt bekommen,</li><li>an den zugehörigen Foren der Produkte teilnehmen (z.B Fragen stellen),</li><li>eigene Produkte anbieten: Dienstleistungen, Software, Dokumente, Hardware und sonstige Angebote, Gebrauchtsoftware und Software für Forschung und Lehre und Ausschreibungen.</li></ul>",
    title: "Was haben Sie von einer Registrierung?",
    key: 2,
  },
  {
    content: " <ul><li>Sie sind z.B. in einer Klinik oder einer forschenden Einrichtung beschäftigt? Das Einstellen eines Produktes ist kostenlos. Bei einem Verkauf erhält Ayacandas eine Provision und übernimmt dafür aber auch die Gewährleistung. Die Firma Ayacandas übernimmt große Teile der Themen Garantie und Gewährleistung, jedoch muss dazu bei Programmen der Quellcode offengelegt werden, auch für den Käufer.</li><li>Sie bieten als Firma oder Vertretung einer Firma an?   Sie bezahlen eine Gebühr für das Einstellen in den Marktplatz und die oder der Suchende bekommt bei der Ergebnisanzeige Ihre vollständigen Daten.Als kommerzieller Anbieter ist selbstverständlich <u>keine</u> Offenlegung des Codes gefordert.</li><ul>",
    title: "Wie finanziert sich der Marktplatz? ",
    key: 3,
  },
  {
    content: "Sie müssen vertretungsberechtigt sein, das anzubieten, was Sie einstellen  und es wäre ratsam, dass sie Forenanfragen zu Ihrem Produkt beantworten. ",
    title: "Gibt es Pflichten, wenn ich Produkte einstelle?",
    key: 4,
  },
];


export class Landing extends Component {

  constructor (props) {
    super(props);
    this.state = {productID:null,
                  username: this.props.username
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.username !== this.state.username) {
      this.setState({username: nextProps.username});
    }
  }

  render() {
    return (
      <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        {/* TODO: delete this div (ContentWithBackground) if the background pic works fine on .APP */}
        <div className="ContentWithBackground">
          <div className="content" id="content">
            {/*  This is the first routing with a function on button to get to the the value of input."
            <Link to="/login">Login *</Link> <br />
            <Link to="/about">About Me</Link><br />
            <Link to="/product/3">Product *</Link> <br />
            <input type="text" value={this.state.productID} placeholder="ID"
            onChange={(event)=>this.setState({productID:event.target.value})}/>
            <input type="button"
            onClick={()=>this.props.history.push("/product/"+this.state.productID)}></input>
            */}
            <div className="contentHeaderLanding">
              Ayacandas ist der Online-Austausch-Marktplatz<br/>
              für IT-Lösungen im Gesundheitswesen
            </div>
            <div className="landingTiles">
              <div className="landingTileUp marginTop20"  >
                <div className="landingTileUpContent">
                  <Link to="/search"><img src={iconMagnifier} alt="magnifier"/></Link><br/>
                  <div className="landingHeaderText">Suche
                  </div>
                  <div className="landingContentText">
                    Suchen <br/>
                    Finden <br/>
                    Inspirieren lassen <br/>
                  </div>
                </div>

                  <div style={{display:'flex',justifyContent:'center', padding: '1%', marginTop: '3%', marginBottom: '5%'}}>
                    <input className="landingSearchInput hoverYellow1" placeholder="im Marktplatz suchen"
                         onChange={ (event) => localStorage.setItem('ayacandas_search', event.target.value) }
                         onKeyPress={event => event.key === 'Enter' ? this.props.history.push("/search") : null} />
                    <div style={{display:"flex",alignSelf:"center", marginLeft:'8px'}}>
                      <Link to="/search"><img src={iconMagnifier} alt="magnifier" height="25"/></Link>
                    </div>
                  </div>
              </div>
              <div className="landingTileDown">

                  
                  { (util.isCommercialUser() || util.isNonCommercialUser()) && 
                   
                    <div className="landingTileDownOneTileToggle">
                    <img src={iconSearchSuggestion} alt="searchSuggestion" /><br/>
                    <div className="landingHeaderText">Suchanregungen</div> 
                    <div className="landingContentText">
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('Entlassmanagement', this.props.history)}> Entlassmanagement </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('Verordnungsmanagement', this.props.history)}>  Verordnungsmanagement </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('OH KIS', this.props.history)}> OH KIS </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('Datenschutz', this.props.history)}> Datenschutz </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('DSGVO', this.props.history)}> DSGVO </span><br/>
                      <span className="landingClickableProducts" onClick={event => util.redirectToSearch('Baurecht', this.props.history)}>Baurecht</span><br />
                    </div>
                  </div>
                  }

                  { (!util.isCommercialUser() && !util.isNonCommercialUser()) && 
                  <div className="landingTileDownOneTile center">
                  <div className="landingOneTileContent">
                    <img src={iconSearchSuggestion} alt="searchSuggestion" /><br/>
                    <div className="landingHeaderText">Suchanregungen</div> 
                    <div className="landingContentText">
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('Entlassmanagement', this.props.history)}> Entlassmanagement </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('Verordnungsmanagement', this.props.history)}>  Verordnungsmanagement </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('OH KIS', this.props.history)}> OH KIS </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('Datenschutz', this.props.history)}> Datenschutz </span><br/>
                     <span  className="landingClickableProducts" onClick={event => util.redirectToSearch('DSGVO', this.props.history)}> DSGVO </span><br/>
                      <span className="landingClickableProducts" onClick={event => util.redirectToSearch('Baurecht', this.props.history)}>Baurecht</span><br />
                    </div>
                    </div>
                  </div>
                }

         
                  {/* if user is not signed in, show the tile. */} 
                  {!util.isCommercialUser() && !util.isNonCommercialUser() &&
                  <div className="landingTileDownOneTile center">
                  <div className="landingOneTileContent">
                    <img src={iconOffer} alt="offer" /><br/>
                    <div className="landingHeaderText">Anbieten</div>
                    <div className="landingContentText">
                      Registrieren <br/>
                      Publizieren<br/>
                      Verkaufen lassen <br/>
                      <br />
                      <Link className="landingLink" to="/login">Login/Registrieren</Link>
                    </div>
                  </div>
                </div>
                  }

                </div>
             
                <div className="landingTileDown">
                <div className="landingTileDownOneTile center" onClick={(event) => this.props.history.push("/update")}>
                  <div className="landingOneTileContent Hand">
                    <img src={iconNews} alt="news" /><br/>
                    <div className="landingHeaderText LandingTileLink">Aktuelles</div>
                  </div>
                </div>
                <div className="landingTileDownOneTile"  onClick={event => this.props.history.push("/videos") }>
                  <div className="landingOneTileContent Hand">
                    <img src={iconInformativ} alt="news" /><br/>
                    <div className="landingHeaderText LandingTileLink">Informatives</div>
                  </div>
                </div>
              </div>
            </div>
            </div>
      
        </div>
        <Footer faqs={faqLanding} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing.js